import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Footer } from "../components/Footer";

export function Consent({
  handleNext,
  handleBack,
  activeStep,
  steps,
  onSubmit,
  handleDataSubmitted,
}: {
  handleNext: () => void;
  handleBack: () => void;
  activeStep: number;
  steps: string[];
  onSubmit: (consent: {
    termsTimestamp: string;
    popiaTimestamp: string;
  }) => void;
  handleDataSubmitted?: (data: Record<string, string>, step: string) => void;
}) {
  const [acknowledge, setAcknowledge] = useState(false);
  const [popiaConsent, setPopiaConsent] = useState(false);
  const [termsTimestamp, setTermsTimestamp] = useState<string>("");
  const [popiaTimestamp, setPopiaTimestamp] = useState<string>("");

  const canSubmit = acknowledge && popiaConsent;

  const handleFinal = () => {
    if (!canSubmit) return;
    if (handleDataSubmitted) {
      handleDataSubmitted(
        {
          "terms-consent-timestamp": termsTimestamp,
          "popia-consent-timestamp": popiaTimestamp,
        },
        "consent"
      );
    }
    onSubmit({
      termsTimestamp,
      popiaTimestamp,
    });
  };

  return (
    <>
      <h4 style={{ borderBottom: "1px solid #ccc", margin: "1em 0" }}>
        Acknowledge disclaimers & POPIA consent
      </h4>
      <div style={{ paddingBottom: "5em" }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Please confirm that the information provided is true and correct to
          the best of your knowledge. By providing your POPIA consent, you
          acknowledge and agree to the processing of your personal information
          for the purposes of assessing and processing this claim.
        </Typography>
        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Terms & Conditions
          </Typography>
          <iframe
            title="Terms & Conditions"
            src="https://siragoapiprod.azure-api.net/siragoGap?cmd=getTerms"
            style={{
              width: "100%",
              height: "70vh",
              border: "1px solid #ddd",
              borderRadius: 6,
            }}
          />
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={acknowledge}
              onChange={(e) => {
                const checked = e.target.checked;
                setAcknowledge(checked);
                if (checked) setTermsTimestamp(new Date().toISOString());
              }}
            />
          }
          label="I acknowledge the Declaration by Applicant."
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={popiaConsent}
              onChange={(e) => {
                const checked = e.target.checked;
                setPopiaConsent(checked);
                if (checked) setPopiaTimestamp(new Date().toISOString());
              }}
            />
          }
          label="I provide POPIA consent."
        />

        <Box
          sx={{ display: "flex", flexDirection: "column", py: 2, mb: "10em" }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1, fontSize: "1.2em" }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            <Button
              onClick={handleFinal}
              sx={{ fontSize: "1.2em" }}
              disabled={!canSubmit}
            >
              Submit
            </Button>
          </Box>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              alignSelf: "flex-end",
              textAlign: "right",
            }}
          >
            Please read and tick both consent checkboxes to enable Submit
          </Typography>
        </Box>
      </div>
      <Footer />
    </>
  );
}
